<template>
  <div class="page-report">
    <iframe v-if="iFrameUrl !== ''"
      :src="iFrameUrl"
      frameborder="0"
      width="100%"
      height="100%"
    ></iframe>
    <div class="position-fixed top-1 end-1 z-index-2 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <material-loading :active="loaderActive" />
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "bootstrap/js/dist/modal";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import AnalyticsService from "../../services/analytics.service";
import CommonFunctionService from "../../services/commonFunction.service";
import TokenService from "../../services/token.service";
import "datatables.net";

export default {
  name: "HourlySalesHeatmap",
  components: {
    MaterialSnackbar,
    MaterialLoading,
  },
  data() {
    return {
      isLoadDone: false,
      isLoadDoneDataTable: false,
      token: TokenService.getLocalAccessToken(),
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      message: "",
      snackbar: null,
      loaderActive: false,
      iFrameUrl: "",
      dashboard_id: process.env.VUE_APP_HOURLY_HEATMAP_DASHBOARD_ID,
    };
  },

  async created() {
    this.getMetaEmbed();
  },
  methods: {
    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },

    dateFormat(date) {
      if (date == null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    getMetaEmbed() {
      this.isLoadDone = false;
      this.isLoadDoneDataTable = false;
      this.showLoader();
      var dataForm = {
        dashboard_id: this.dashboard_id
      };
      AnalyticsService.getMetaEmbed(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.iFrameUrl = response.data.data.iframe_url
            this.isLoadDone = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },
  },
  watch: {
    isLoadDone(val) {
      if (val) {
        setTimeout(() => {
          this.isLoadDoneDataTable = true;
        }, 100);
      }
    },
  },
};
</script>
<style scoped>
  .page-report {
    height: 97vh;
    overflow: hidden;
  }
</style>
